import { analytics } from "@/lib/analytics";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { FiZap } from "react-icons/fi";
import { noindexHead } from "@/lib/seo";

type FormValues = { name: string };

export const Route = createFileRoute("/libs")({
  component: LibsDemo,
  head: () => noindexHead("Libs | Lutely"),
});

function LibsDemo() {
  const { register, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: { name: "" },
  });

  const onSubmit = handleSubmit((values) => {
    analytics.track("demo_form_submit", values);
    reset();
  });

  return (
    <div className="mx-auto max-w-3xl p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Core Libs Demo</h1>

      <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <h2 className="text-sm font-medium uppercase tracking-wider text-slate-500 mb-2">
          date-fns
        </h2>
        <p>Today is {format(new Date(), "PP")}</p>
      </section>

      <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 shadow-sm space-y-3">
        <h2 className="text-sm font-medium uppercase tracking-wider text-slate-500">
          React Hook Form
        </h2>
        <form onSubmit={onSubmit} className="flex items-center gap-2">
          <input
            {...register("name")}
            placeholder="Your name"
            className="px-3 py-2 rounded border bg-transparent"
          />
          <button className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-3 py-2 text-white hover:bg-blue-700">
            <FiZap /> Submit
          </button>
        </form>
      </section>

      <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <h2 className="text-sm font-medium uppercase tracking-wider text-slate-500 mb-2">
          Mixpanel
        </h2>
        <button
          className="inline-flex items-center gap-2 rounded-md bg-emerald-600 px-3 py-2 text-white hover:bg-emerald-700"
          onClick={() =>
            analytics.track("demo_button_click", { source: "libs" })
          }
        >
          Track Click
        </button>
        <p className="text-xs text-slate-500 mt-2">
          If no Mixpanel token is set, events log to console in dev.
        </p>
      </section>
    </div>
  );
}
